import { siteName, timeline } from '@/mocks/chigua';

export default function Breaking() {
  const items = timeline.map((t) => `${t.title}（${t.cat}）`);
  const doubled = [...items, ...items];

  return (
    <div className="flex items-stretch border-b border-secondary-100 bg-foreground-950 text-background-50">
      <div className="relative z-10 flex shrink-0 items-center gap-1.5 bg-accent-500 px-3 py-2.5 md:px-5">
        <i className="ri-broadcast-line text-base text-foreground-950 md:text-lg"></i>
        <span className="heading-font text-xs font-bold tracking-widest text-foreground-950 md:text-sm">
          全网速报
        </span>
      </div>
      <div className="relative flex flex-1 items-center overflow-hidden">
        <div className="flex w-max animate-ticker items-center whitespace-nowrap">
          {doubled.map((it, i) => (
            <span key={i} className="flex items-center text-xs md:text-sm">
              <span className="px-5 text-background-100">{it}</span>
              <i className="ri-flashlight-fill text-accent-400 text-[10px]"></i>
            </span>
          ))}
        </div>
        <div className="pointer-events-none absolute inset-y-0 left-0 w-10 bg-gradient-to-r from-foreground-950 to-transparent"></div>
        <div className="pointer-events-none absolute inset-y-0 right-0 w-10 bg-gradient-to-l from-foreground-950 to-transparent"></div>
      </div>
      <a
        href="#ts"
        aria-label={`前往${siteName}今日速览`}
        className="hidden shrink-0 items-center gap-1 bg-primary-500 px-4 text-xs font-semibold text-background-50 transition-colors hover:bg-primary-600 md:flex"
      >
        进入速览 <i className="ri-arrow-right-line"></i>
      </a>
    </div>
  );
}